"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/missionSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type MissionSectionMissionThreesItem = {
    key: Key | null | undefined;
    /** Detected variants: "mission-item-three" | "mission-item-three mb-0" */
    className: string;
    /** Detected variants: "mission-icon bg-success" | "mission-icon bg-cyan" | "mission-icon bg-pink" */
    div0ClassName: string;
    /** Detected variants: "/Templates/Doccure/img/icons/target-icon-1.svg" | "/Templates/Doccure/img/icons/target-icon-2.svg" | "/Templates/Doccure/img/icons/target-icon-3.svg" */
    src: string;
    /** Detected variants: "Our Mission" | "Our Vision" | "Why We Care" */
    h30Text: ReactNode;
    /** Detected variants: "To provide exceptional dental care with compassion, the latest technology, ensuring patient leaves with a brighter smile." | "To be the most trusted dental clinic, known for transforming lives through advanced, painless & personalized patient care." | "Oral health is vital to overall well-being. We're passionate about educating and empowering our patients to healthy smiles for life." */
    p0Text: ReactNode;
    /** Detected variants: "mission-1" */
    alt?: string;
    /** Detected variants: "img-fluid icon-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "mission-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};

type MissionSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-25.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "border border-white" */
    imageWithBasePath0ClassName?: string;
};
export type HomeThreeMissionSectionGeneratedProps = {
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: MissionSectionMissionThreesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: MissionSectionMissionThreesItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "fade-up" */
    sectionDiv0Div0Div0Div0Div0DivDataAos?: string;
    /** Default: "Who We Are" */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "More then 25K clients" */
    sectionDiv0Div0Div0Div0Div1Div1P0PText?: ReactNode;
    /** Default: "reviews" */
    sectionDiv0Div0Div0Div0Div1Div1P0Span0SpanText?: ReactNode;
    /** Default: 12 */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "element" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-element-1.svg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "YEARS OF DENTAL" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "EXPERIENCE" */
    sectionDiv0Div0Div0Div0P0Span0SpanText?: ReactNode;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/element-dent-03.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: MissionSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    missionSectionMissionThrees: MissionSectionMissionThreesItem[];
    missionSectionAvatarAvatarRoundeds: MissionSectionAvatarAvatarRoundedsItem[];
    missionSectionMissionThreesItemWrapper?: (item: MissionSectionMissionThreesItem, content: ReactNode) => ReactNode;
    missionSectionMissionThreesRenderer?: (defaultNode: ReactNode) => ReactNode;
    missionSectionMissionThreesImageVisible?: boolean;
    missionSectionMissionThreesImageRenderer?: (item: MissionSectionMissionThreesItem, defaultNode: ReactNode) => ReactNode;
    missionSectionMissionThreesH3Visible?: boolean;
    missionSectionMissionThreesH3Renderer?: (item: MissionSectionMissionThreesItem, defaultNode: ReactNode) => ReactNode;
    missionSectionMissionThreesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: MissionSectionMissionThreesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    missionSectionMissionThreesH3Props?: Partial<ComponentProps<"h3">> | ((item: MissionSectionMissionThreesItem) => Partial<ComponentProps<"h3">>);
    missionSectionAvatarAvatarRoundedsItemWrapper?: (item: MissionSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    missionSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    missionSectionAvatarAvatarRoundedsImageVisible?: boolean;
    missionSectionAvatarAvatarRoundedsImageRenderer?: (item: MissionSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    missionSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: MissionSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeThreeMissionSectionGenerated: FC<HomeThreeMissionSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivDataAos = "fade-up",
    sectionDiv0Div0Div0Div0Div0P0PText = "Who We Are",
    sectionDiv0Div0Div0Div0Div1Div1P0PText = "More then 25K clients",
    sectionDiv0Div0Div0Div0Div1Div1P0Span0SpanText = "reviews",
    sectionDiv0Div0Div0Div0H20H2Text = 12,
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "element",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-element-1.svg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0P0PText = "YEARS OF DENTAL",
    sectionDiv0Div0Div0Div0P0Span0SpanText = "EXPERIENCE",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/element-dent-03.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    missionSectionMissionThrees,
    missionSectionAvatarAvatarRoundeds,
    missionSectionMissionThreesItemWrapper,
    missionSectionMissionThreesRenderer,
    missionSectionMissionThreesImageVisible,
    missionSectionMissionThreesImageRenderer,
    missionSectionMissionThreesH3Visible,
    missionSectionMissionThreesH3Renderer,
    missionSectionMissionThreesImageProps,
    missionSectionMissionThreesH3Props,
    missionSectionAvatarAvatarRoundedsItemWrapper,
    missionSectionAvatarAvatarRoundedsRenderer,
    missionSectionAvatarAvatarRoundedsImageVisible,
    missionSectionAvatarAvatarRoundedsImageRenderer,
    missionSectionAvatarAvatarRoundedsImageProps,
}) => {
    return (
        <section className="mission-section mission-section-three section overflow-hidden">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="mission-left">
                            <div className="section-header section-header-three aos" data-aos={sectionDiv0Div0Div0Div0Div0DivDataAos}>
                                <p className="title">
                                    <i className="fa-solid fa-circle" />
                                    {sectionDiv0Div0Div0Div0Div0P0PText}
                                </p>
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="mission-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                            <p className="mission-sub-title">
                                {sectionDiv0Div0Div0Div0P0PText}
                                <span className="d-block">{sectionDiv0Div0Div0Div0P0Span0SpanText}</span>
                            </p>
                            <div className="rating-appointment flex-wrap gap-2">
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        missionSectionAvatarAvatarRoundeds,
                                        (item: MissionSectionAvatarAvatarRoundedsItem) => (
                                            <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(missionSectionAvatarAvatarRoundedsImageVisible, missionSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "border border-white"} src={item.src} alt={item.alt ?? "img"} {...(typeof missionSectionAvatarAvatarRoundedsImageProps === "function" ? missionSectionAvatarAvatarRoundedsImageProps(item) : (missionSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        missionSectionAvatarAvatarRoundedsItemWrapper,
                                        missionSectionAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                                <div>
                                    <p className="avatar-ttile">
                                        {sectionDiv0Div0Div0Div0Div1Div1P0PText}
                                        <span className="d-block">{sectionDiv0Div0Div0Div0Div1Div1P0Span0SpanText}</span>
                                        {" "}
                                    </p>
                                </div>
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6 mission-right">
                        {renderCollectionNode(
                            missionSectionMissionThrees,
                            (item: MissionSectionMissionThreesItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName}>
                                        {renderItemNode(missionSectionMissionThreesImageVisible, missionSectionMissionThreesImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "mission-1"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon-1"} {...(typeof missionSectionMissionThreesImageProps === "function" ? missionSectionMissionThreesImageProps(item) : (missionSectionMissionThreesImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "mission-content"}>
                                        {renderItemNode(missionSectionMissionThreesH3Visible, missionSectionMissionThreesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof missionSectionMissionThreesH3Props === "function" ? missionSectionMissionThreesH3Props(item) : (missionSectionMissionThreesH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            missionSectionMissionThreesItemWrapper,
                            missionSectionMissionThreesRenderer
                        )}
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThreeMissionSectionGenerated;
